<template>
	<div class="circle-color">
		<button
			ref="nodeBtn"
			class="circle-color__btn"
			:class="{ 'circle-color__btn--show-icon' : '1' === persistentIcon }"
			type="button"
			@click="emit( 'btn:click' )"
		>
			<div
				ref="nodeBtnIcon"
				class="circle-color__btn__icon"
			>
				<slot name="icon" />
			</div>

			<!-- <div
				v-if="image"
				:class="{ 'image-has-loaded' : imageHasLoaded }"
				class="circle-color__btn__img-loader"
			/> -->

			<img
				v-if="image"
				:class="{ 'has-loaded' : imageHasLoaded }"
				class="circle-color__btn__img"
				:src="image"
				:alt="label"
				@load="handleBtnImageLoad"
			>
		</button>

		<div class="circle-color__label">
			{{ label }}
		</div>
	</div>
</template>


<style lang="scss">
@import 'npm:tippy.js/dist/tippy.css';

.circle-color {
	$transitionSpeed: 0.125s;
	$transitionType: linear;

	display: flex;
	flex-direction: column;
	place-items: center;
	width: 100%;
	border: none;
	background-color: transparent;

	&__btn {
		$btn: &;
		position: relative;
		display: flex;
		place-content: center;
		place-items: center;
		width: 100%;
		max-width: 180px;
		aspect-ratio: 1;
		overflow: hidden;
		border: 11px solid white;
		border-radius: 50%;
		background-color: #e5e5e5;
		box-shadow: 1px 3px 10px 0px rgba(0,0,0,0.3);
		-webkit-appearance: none;
		-moz-appearance: none;
		appearance: none;
		z-index: 2000;

		&__img-loader {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			display: flex;
			place-content: center;
			place-items: center;
			background-color: #0093c9;
			z-index: 3000;
			transition: $transitionSpeed $transitionType;

			&:before {
				content: '';
				display: block;
				width: 30px;
				height: 30px;
				border-radius: 50%;
				border: 4px solid;
				border-color: white transparent;
				animation: loaderSpin 1s infinite $transitionType;
				transition: $transitionType;
			}

			&.image-has-loaded {
				opacity: 0;
				visibility: hidden;
			}
		}

		&__icon {
			position: absolute;
			top: 50%;
			left: 50%;
			display: flex;
			place-content: center;
			place-items: center;
			transform: translate( -50%, -50% );
			z-index: 1000;
			opacity: 0;
			visibility: hidden;
			transition: $transitionSpeed $transitionType;
			z-index: 2000;

			#{$btn}:hover &,
			#{$btn}--show-icon & {
				opacity: 1;
				visibility: visible;
			}

			svg {
				width: 36px;
				height: auto;
			}
		}

		&__img {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			object-fit: cover;
			z-index: 1000;
		}
	}

	&__label {
		margin-top: 8px;
		margin-bottom: 16px;
		font-weight: bold;
		font-size: 14px;
		text-align: center;
	}
}

@keyframes loaderSpin {
	0% {
		transform: rotate( 0deg );
	}

	100% {
		transform: rotate( 360deg );
	}
}
</style>


<script setup>
import { onMounted, onUnmounted, ref } from 'vue'


const props = defineProps({
	label: {
		type: String,
		required: true,
	},
	image: {
		type: String,
		default: '',
	},
	persistentIcon: {
		type: String, // todo -- can I cast to bool?
		default: '',
	},
	iconTooltip: {
		type: String,
		default: '',
	},
})


const emit = defineEmits(
	[
		'btn:click',
	],
)


const imageHasLoaded = ref( false )

const nodeBtn = ref( null )
const nodeBtnIcon = ref( null )

let btnIconTippy = null


/**
 * Handle image load
 *
 * @todo Add loading animation to "smooth" component load?
 *
 * @return {void}
 */
const handleBtnImageLoad = () => {
	imageHasLoaded.value = true
}


onMounted( () => {
	if ( props.iconTooltip ) {
		import( 'tippy.js' ).then( tippy => {
			btnIconTippy = tippy.default( nodeBtnIcon.value, {
				content: props.iconTooltip,
				placement: 'top',
			})

			nodeBtn.value.addEventListener( 'mouseenter', btnIconTippy.show )
			nodeBtn.value.addEventListener( 'mouseleave', btnIconTippy.hide )
		})
	}

})


onUnmounted( () => {
	if ( btnIconTippy ) {
		btnIconTippy.destroy()
	}
})

</script>

